/* eslint-disable */
import React from "react";
import clsx from "clsx";
import { StandardProps } from "../common";

import "./Typography.scss";

interface TypographyProps extends StandardProps {
  /**
   * The variant to use.
   */
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "s1"
    | "s2"
    | "s3"
    | "overline1"
    | "overline2"
    | "overline3"
    | "caption1"
    | "caption2"
    | "body1"
    | "body2";
  /**
   * The component to render as. Use a string to render an HTML element or a component to render that component.
   */
  as?:
    | "div"
    | "p"
    | "span"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | React.ElementType;
  fontWeight?: "extralight" | "regular" | "medium" | "bold" | "extrabold";
  align?: "inherit" | "left" | "center" | "right" | "justify";
  /**
   * If true, adds bottom margin to the text.
   */
  children: React.ReactNode;
  gutterBottom?: boolean;
}

const Typography = ({
  variant = "body1",
  as = "div",
  gutterBottom = false,
  fontWeight,
  align = "inherit",
  ...props
}: TypographyProps) => {
  const Component = as;

  return (
    <Component
      className={clsx([
        "typography",
        `typography-variant-${variant}`,
        gutterBottom && "gutter-bottom",
        fontWeight && `weight-${fontWeight}`,
        align && `align-${align}`,
      ])}
      {...props}
    />
  );
};

export default Typography;
